import Text from '@/components/ui/custom/dataDisplay/Text';
import TrophyWithPosition from '@/pages/project/hackathon/TrophyWithPosition';

type RankingProps = {
  position: number;
};
export default function Ranking({ position }: RankingProps) {
  if (position >= 1 && position <= 3) {
    return (
      <TrophyWithPosition
        position={position}
        className={{
          icon: 'w-7 h-7',
          text: 'text-12 !text-base-100 top-0.5 right-2',
        }}
      />
    );
  }
  return (
    <div className="rounded-full min-w-6 h-6 flex items-center justify-center bg-primary px-1">
      <Text text={position + 'º'} className="text-base-100" />
    </div>
  );
}
